<template>
  <div>
      <!-- {{assignment}} -->
    <div class="mb-2">
      <label class="vs-input--label">{{type}} Title</label>
      <vs-input
      :disabled="formType=='Preview'?true:false"
        class="w-full"
        v-model="assignment.question_section_title"
        placeholder="Title"
        v-validate="'required'"
        name="title"
        data-vv-name="title"
      />
      <span
        v-show="errors.has('Questions.title')"
        class="text-danger block"
        >{{ errors.first('Questions.title') }}</span
      >
    </div>

    <div class="mb-2">
      <label class="vs-input--label">{{type}} Description</label>
      <vs-textarea
      :disabled="formType=='Preview'?true:false"
        class="mb-0"
        height="50px"
        v-model="assignment.question_section_description"
        placeholder="Description"
      />
    </div>
  </div>
</template>

<script>
export default {
  props:{
    type:{
      default:''
    },
    formType:{
      default:''
    },
    value:{
      type:Object,
      required:true
    }
  },
  
  computed: {
    assignment: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
</style>